import { useMutation } from '@apollo/client';
import { TrashIcon } from '@heroicons/react/20/solid';
import { DESTROY_ACCOUNT_CREDIT_CARD } from '@retainerclub/shared-api';
import PropTypes from 'prop-types';

function DestroyAccountCreditCard({ id, refetch = null, defaultCard = false }) {
  const [destroy] = useMutation(DESTROY_ACCOUNT_CREDIT_CARD);

  async function handleDestroy() {
    try {
      const params = {
        variables: {
          input: {
            id,
            clientMutationId: crypto.randomUUID(),
          },
        },
      };

      const { data } = await destroy(params);

      const { accountCreditCard } = data.destroyAccountCreditCard;

      if (accountCreditCard && refetch) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    }
  }

  return !defaultCard ? (
    <button
      type="button"
      className="-ml-px relative inline-flex items-center rounded-r-md bg-white px-3 py-2 font-semibold text-gray-900 text-sm ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-10"
      onClick={() => handleDestroy()}
    >
      <TrashIcon className="size-4" aria-hidden="true" />
    </button>
  ) : null;
}

DestroyAccountCreditCard.propTypes = {
  id: PropTypes.string.isRequired,
  refetch: PropTypes.func,
  defaultCard: PropTypes.bool,
};

export default DestroyAccountCreditCard;
